<template>
    <articles-chooser v-model="articles" class="my-3" />
</template>

<script>
import ArticlesChooser from '@/components/elements/ArticlesChooser';

export default {
    components: {
        ArticlesChooser
    },

    props: {
        value: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            articles: [...this.value.filter(val => val && val.id)]
        };
    },

    watch: {
        articles() {
            this.$emit('input', this.articles);
        }
    }
};
</script>
